function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
import memoize from 'memoize-one';
import { GridRange } from '@deephaven/grid';
import Log from '@deephaven/log';
import { Formatter } from '@deephaven/jsapi-utils';
import { EventShimCustomEvent, PromiseUtils, assertNotNull, EMPTY_ARRAY } from '@deephaven/utils';
import IrisGridModel from "./IrisGridModel.js";
import IrisGridTableModelTemplate from "./IrisGridTableModelTemplate.js";
var log = Log.module('IrisGridTableModel');

/**
 * Model for a grid showing an iris data table
 */

class IrisGridTableModel extends IrisGridTableModelTemplate {
  /**
   * @param dh JSAPI instance
   * @param table Iris data table to be used in the model
   * @param formatter The formatter to use when getting formats
   * @param inputTable Iris input table associated with this table
   */
  constructor(dh, table) {
    var formatter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Formatter(dh);
    var inputTable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    super(dh, table, formatter, inputTable);
    _defineProperty(this, "userFrozenColumns", void 0);
    _defineProperty(this, "customColumnList", void 0);
    _defineProperty(this, "formatColumnList", void 0);
    _defineProperty(this, "initialFilters", []);
    // The initial value for table.isUncoalesced on the source table before any transformations (e.g. filter, select)
    _defineProperty(this, "wasUncoalesced", void 0);
    _defineProperty(this, "getMemoizedKeyColumnSet", memoize(inputTableKeys => new Set(inputTableKeys !== null && inputTableKeys !== void 0 ? inputTableKeys : EMPTY_ARRAY)));
    _defineProperty(this, "getMemoizedValueColumnSet", memoize(inputTableValues => new Set(inputTableValues !== null && inputTableValues !== void 0 ? inputTableValues : EMPTY_ARRAY)));
    _defineProperty(this, "getMemoizedFrontColumns", memoize(layoutHintsFrontColumns => layoutHintsFrontColumns !== null && layoutHintsFrontColumns !== void 0 ? layoutHintsFrontColumns : EMPTY_ARRAY));
    _defineProperty(this, "getMemoizedBackColumns", memoize(layoutHintsBackColumns => layoutHintsBackColumns !== null && layoutHintsBackColumns !== void 0 ? layoutHintsBackColumns : EMPTY_ARRAY));
    _defineProperty(this, "getMemoizedFrozenColumns", memoize((layoutHintsFrozenColumns, userFrozenColumns) => {
      var _ref;
      return (_ref = userFrozenColumns !== null && userFrozenColumns !== void 0 ? userFrozenColumns : layoutHintsFrozenColumns) !== null && _ref !== void 0 ? _ref : EMPTY_ARRAY;
    }));
    _defineProperty(this, "getCachedFilterableColumnSet", memoize(columns => new Set(columns.map((_, index) => index))));
    _defineProperty(this, "getCachedPartitionColumns", memoize(columns => columns.filter(column => column.isPartitionColumn)));
    this.customColumnList = [];
    this.formatColumnList = [];
    this.initialFilters = table.filter;
    this.wasUncoalesced = this.isPartitionRequired;
  }
  get isExportAvailable() {
    return this.table.freeze != null;
  }
  get isColumnStatisticsAvailable() {
    return this.table.getColumnStatistics != null;
  }
  get isRollupAvailable() {
    return this.table.rollup != null;
  }
  get isSelectDistinctAvailable() {
    return this.table.selectDistinct != null;
  }
  get isOrganizeColumnsAvailable() {
    return true;
  }
  get isCustomColumnsAvailable() {
    return this.table.applyCustomColumns != null;
  }
  get isFormatColumnsAvailable() {
    return this.table.applyCustomColumns != null;
  }
  get keyColumnSet() {
    var _this$inputTable;
    return this.getMemoizedKeyColumnSet((_this$inputTable = this.inputTable) === null || _this$inputTable === void 0 ? void 0 : _this$inputTable.keys);
  }
  get valueColumnSet() {
    var _this$inputTable2;
    return this.getMemoizedValueColumnSet((_this$inputTable2 = this.inputTable) === null || _this$inputTable2 === void 0 ? void 0 : _this$inputTable2.values);
  }
  get frontColumns() {
    var _this$layoutHints$fro, _this$layoutHints;
    return this.getMemoizedFrontColumns((_this$layoutHints$fro = (_this$layoutHints = this.layoutHints) === null || _this$layoutHints === void 0 ? void 0 : _this$layoutHints.frontColumns) !== null && _this$layoutHints$fro !== void 0 ? _this$layoutHints$fro : undefined);
  }
  get backColumns() {
    var _this$layoutHints$bac, _this$layoutHints2;
    return this.getMemoizedBackColumns((_this$layoutHints$bac = (_this$layoutHints2 = this.layoutHints) === null || _this$layoutHints2 === void 0 ? void 0 : _this$layoutHints2.backColumns) !== null && _this$layoutHints$bac !== void 0 ? _this$layoutHints$bac : undefined);
  }
  get frozenColumns() {
    var _this$layoutHints$fro2, _this$layoutHints3;
    return this.getMemoizedFrozenColumns((_this$layoutHints$fro2 = (_this$layoutHints3 = this.layoutHints) === null || _this$layoutHints3 === void 0 ? void 0 : _this$layoutHints3.frozenColumns) !== null && _this$layoutHints$fro2 !== void 0 ? _this$layoutHints$fro2 : undefined, this.userFrozenColumns);
  }
  get layoutHints() {
    return this.table.layoutHints;
  }
  get floatingLeftColumnCount() {
    return this.frozenColumns.length;
  }
  get description() {
    var _this$table$descripti;
    return (_this$table$descripti = this.table.description) !== null && _this$table$descripti !== void 0 ? _this$table$descripti : '';
  }
  get customColumns() {
    return this.customColumnList;
  }
  set customColumns(customColumns) {
    log.debug2('set customColumns', customColumns, this.customColumnList, customColumns === this.customColumnList);
    if (this.customColumnList.length === 0 && customColumns.length === 0) {
      log.debug('Ignore empty initial customColumns');
      this.customColumnList = customColumns;
      return;
    }
    if (this.customColumnList === customColumns) {
      log.debug('Ignore same customColumns');
      return;
    }
    this.closeSubscription();
    this.customColumnList = customColumns;
    this.table.applyCustomColumns([...customColumns, ...this.formatColumns]);
    this.applyViewport();
  }
  get formatColumns() {
    return this.formatColumnList;
  }
  set formatColumns(formatColumns) {
    log.debug2('set formatColumns', formatColumns, this.formatColumnList, formatColumns === this.formatColumnList);
    if (this.formatColumnList.length === 0 && formatColumns.length === 0) {
      log.debug('Ignore empty initial formatColumns');
      this.formatColumnList = formatColumns;
      return;
    }
    if (this.formatColumnList === formatColumns) {
      log.debug('Ignore same formatColumns');
      return;
    }
    this.closeSubscription();
    this.formatColumnList = formatColumns;
    this.table.applyCustomColumns([...this.customColumns, ...formatColumns]);
    this.applyViewport();
  }
  updateFrozenColumns(columns) {
    this.userFrozenColumns = columns;
    this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.COLUMNS_CHANGED, {
      detail: this.columns
    }));
  }
  get partitionColumns() {
    return this.getCachedPartitionColumns(this.columns);
  }
  partitionKeysTable() {
    var _this = this;
    return _asyncToGenerator(function* () {
      return _this.valuesTable(_this.partitionColumns);
    })();
  }
  partitionMergedTable() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var t = yield _this2.table.copy();
      t.applyFilter([]);
      return t;
    })();
  }
  partitionBaseTable() {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      return _this3.partitionKeysTable();
    })();
  }
  partitionTable(partitions) {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      log.debug('getting partition table for partitions', partitions);
      var partitionFilters = [];
      for (var i = 0; i < _this4.partitionColumns.length; i += 1) {
        var partition = partitions[i];
        var partitionColumn = _this4.partitionColumns[i];
        var partitionFilter = _this4.tableUtils.makeNullableEqFilter(partitionColumn, partition);
        partitionFilters.push(partitionFilter);
      }
      var t = yield _this4.table.copy();
      t.applyFilter([..._this4.initialFilters, ...partitionFilters]);
      return t;
    })();
  }
  set filter(filter) {
    this.closeSubscription();
    this.table.applyFilter([...this.initialFilters, ...filter]);
    this.applyViewport();
  }
  set totalsConfig(totalsConfig) {
    log.debug('set totalsConfig', totalsConfig);
    if (totalsConfig === this.totals) {
      // Totals already set, or it will be set when the next model actually gets set
      return;
    }
    this.totals = totalsConfig;
    this.formattedStringData = [];
    if (this.totalsTablePromise != null) {
      this.totalsTablePromise.cancel();
    }
    this.setTotalsTable(null);
    if (totalsConfig == null) {
      this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.UPDATED));
      return;
    }
    this.totalsTablePromise = PromiseUtils.makeCancelable(this.table.getTotalsTable(totalsConfig), table => table.close());
    this.totalsTablePromise.then(totalsTable => {
      this.totalsTablePromise = null;
      this.setTotalsTable(totalsTable);
    }).catch(err => {
      if (PromiseUtils.isCanceled(err)) {
        return;
      }
      log.error('Unable to set next totalsTable', err);
      this.totalsTablePromise = null;
      this.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.REQUEST_FAILED, {
        detail: err
      }));
    });
  }
  get isFilterRequired() {
    return this.table.isUncoalesced;
  }
  get isPartitionRequired() {
    return this.table.isUncoalesced && this.isValuesTableAvailable && this.partitionColumns.length > 0;
  }
  get isPartitionAwareSourceTable() {
    return this.wasUncoalesced;
  }
  isFilterable(columnIndex) {
    return this.getCachedFilterableColumnSet(this.columns).has(columnIndex);
  }
  export() {
    var _this5 = this;
    return _asyncToGenerator(function* () {
      return _this5.table.freeze();
    })();
  }
  columnStatistics(column) {
    return this.table.getColumnStatistics(column);
  }
  isColumnMovable(modelIndex) {
    var columnName = this.columns[modelIndex].name;
    if (this.frontColumns.includes(columnName) || this.backColumns.includes(columnName) || this.frozenColumns.includes(columnName)) {
      return false;
    }
    return !this.isKeyColumn(modelIndex);
  }
  isColumnFrozen(modelIndex) {
    return this.frozenColumns.includes(this.columns[modelIndex].name);
  }
  delete(ranges) {
    var _superprop_getPendingDataMap = () => super.pendingDataMap,
      _superprop_setPendingDataMap = _value => super.pendingDataMap = _value,
      _this6 = this;
    return _asyncToGenerator(function* () {
      var _this6$inputTable;
      if (!_this6.isDeletableRanges(ranges)) {
        throw new Error("Undeletable ranges ".concat(ranges));
      }
      assertNotNull(_this6.inputTable);
      var keyColumns = _this6.inputTable.keyColumns;
      if (_this6.keyColumnSet.size === 0) {
        throw new Error('No key columns to allow deletion');
      }
      var pendingAreaRange = _this6.getPendingAreaRange();
      var pendingRanges = ranges.map(range => GridRange.intersection(pendingAreaRange, range)).filter(range => range != null).map(range => {
        assertNotNull(range);
        return GridRange.offset(range, 0, -(_this6.floatingTopRowCount + _this6.table.size));
      });
      if (pendingRanges.length > 0) {
        var newDataMap = new Map(_superprop_getPendingDataMap());
        for (var i = 0; i < pendingRanges.length; i += 1) {
          var pendingRange = pendingRanges[i];
          assertNotNull(pendingRange.startRow);
          assertNotNull(pendingRange.endRow);
          for (var r = pendingRange.startRow; r <= pendingRange.endRow; r += 1) {
            newDataMap.delete(r);
          }
        }
        _superprop_setPendingDataMap(newDataMap);
        _this6.formattedStringData = [];
        _this6.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.PENDING_DATA_UPDATED));
        _this6.dispatchEvent(new EventShimCustomEvent(IrisGridModel.EVENT.UPDATED));
      }
      var tableAreaRange = _this6.getTableAreaRange();
      var tableRanges = ranges.map(range => GridRange.intersection(tableAreaRange, range)).filter(range => range != null);
      if (tableRanges.length <= 0) {
        return;
      }
      var _yield$Promise$all = yield Promise.all([
        // Need to get the key values of each row
        _this6.snapshot(tableRanges.map(range => {
          assertNotNull(range);
          // Need to map each key column to it's range so we can pass that into the snapshot function
          return keyColumns.map(keyColumn => {
            var keyIndex = _this6.getColumnIndexByName(keyColumn.name);
            if (keyIndex == null) {
              throw new Error("Key column ".concat(keyColumn.name, " not found"));
            }
            return new GridRange(keyIndex, range.startRow, keyIndex, range.endRow);
          });
        }).flat()), _this6.table.copy()]),
        _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2),
        data = _yield$Promise$all2[0],
        deleteTable = _yield$Promise$all2[1];

      // Now copy the existing table and filter it on the values in the snapshot for the key columns in the input table
      var filters = data.map(row => {
        var columnFilters = [];
        for (var c = 0; c < keyColumns.length; c += 1) {
          var column = keyColumns[c];
          var value = row[c];
          var _filter = _this6.tableUtils.makeNullableEqFilter(column, value);
          columnFilters.push(_filter);
        }
        // Use variadic .and() to keep the per-row filter flat (depth 1) rather than
        // building a deeply nested tree with chained .and() calls.
        return columnFilters.length === 1 ? columnFilters[0] : columnFilters[0].and(...columnFilters.slice(1));
      });

      // Use variadic .or() to keep the combined filter flat (depth 1). Chaining
      // .or() one-at-a-time via reduce creates a tree N levels deep; for 10 000
      // rows the recursive toString() in dh-core exceeds the JS call stack limit.
      var filter = filters.length === 1 ? filters[0] : filters[0].or(...filters.slice(1));
      deleteTable.applyFilter([filter]);
      yield (_this6$inputTable = _this6.inputTable) === null || _this6$inputTable === void 0 ? void 0 : _this6$inputTable.deleteTable(deleteTable);
      deleteTable.close();
    })();
  }
  seekRow(startRow, column, valueType, value, insensitive, contains, isBackwards) {
    var _this7 = this;
    return _asyncToGenerator(function* () {
      return _this7.table.seekRow(startRow, column, valueType, value, insensitive, contains, isBackwards);
    })();
  }
  get isSeekRowAvailable() {
    return this.table.seekRow != null;
  }
}
export default IrisGridTableModel;
//# sourceMappingURL=IrisGridTableModel.js.map